import React from 'react';
import { SelectItem } from '@components/controlled-input-select/src/controlled-input-select.type';
import { BulkHolderInfo } from '@components/forms/bulk-holder/bulk-holder-info';
import { BulkHolderSelectType } from '@components/forms/bulk-holder/bulk-holder-select-type';
import { STEP_INFO, STEP_SELECT_TYPE } from '@constants/process-steps';

import { ProcessAddBulkHolderStep } from './add-bulk-holder-modal.type';

export interface BulkHolderStepsProps {
  step: ProcessAddBulkHolderStep;
  setStep: (step: ProcessAddBulkHolderStep) => void;
  passId: string;
  isLoading: boolean;
  onSubmit: () => void;
  onClose: () => void;
  onSelectSingle: (passId?: string) => void;
  isNominative?: boolean;
  triggerValidation?: (fieldName?: string) => Promise<boolean>;
  passOptions?: SelectItem[];
}

export const BulkHolderSteps: React.FC<BulkHolderStepsProps> = ({
  step,
  setStep,
  passId,
  isLoading,
  onSubmit,
  onClose,
  onSelectSingle,
  isNominative,
  triggerValidation,
  passOptions,
}) => {
  return (
    <>
      {step === STEP_SELECT_TYPE && (
        <BulkHolderSelectType
          onContinue={() => setStep(STEP_INFO)}
          onSelectSingle={onSelectSingle}
          passId={passId}
          passOptions={passOptions}
        />
      )}
      {step === STEP_INFO && (
        <BulkHolderInfo
          onContinue={onSubmit}
          handleClose={onClose}
          isLoading={isLoading}
          isNominative={isNominative}
          triggerValidation={triggerValidation}
        />
      )}
    </>
  );
};
